<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <h4>Расписание:</h4>
      </v-col>
      <v-col v-if="data" cols="2" offset="6">
        <v-btn v-if="!isOnlyEdit" icon :disabled="loading" :loading="loading" @click="$emit('delete', data)">
          <v-icon color="red">mdi-trash-can-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <span>Повтор</span>
        <v-select
          outlined
          no-data-text="Список пуст"
          item-value="id"
          item-text="title"
          :disabled="loading || isOnlyEdit"
          :loading="loading"
          :items="$options.repeatTypes"
          :value="fields.repeatType"
          @change="repeatTypeHandler"
        />
      </v-col>
    </v-row>
    <v-row v-if="fields.repeatType === 'WEEKLY'">
      <v-col v-for="day in $options.weekDays" :key="day.key">
        <v-checkbox
          :label="day.title"
          :value="day.value"
          :disabled="loading || isOnlyEdit"
          :loading="loading"
          v-model="fields.repeatWeekdays"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <span>Дата начала *</span>
        <v-menu
          ref="menuStartDate"
          :close-on-content-click="false"
          min-width="auto"
          v-model="menuStartDate"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-row align="center" no-gutters>
              <v-text-field
              id="startDate"
                hide-details
                outlined
                readonly
                v-bind="attrs"
                :disabled="loading || isOnlyEdit"
                :loading="loading"
                :error-messages="getFieldErrorMessage('startDate', 'Обязательное поле')"
                :value="preparedFormatTime(fields.startDate)"
                v-on="on"
                @change="fields.startDate = prepareDateFormatPayload($event)"
              />
              <v-icon class="ml-2">mdi-calendar</v-icon>
            </v-row>
          </template>
          <v-date-picker
            no-title
            scrollable
            first-day-of-week="1"
            :disabled="loading || isOnlyEdit"
            :value="fields.startDate"
            @change="fields.startDate = prepareDateFormatPayload($event)"
            @input="menuStartDate = false"
          >
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="6">
        <span>Дата окончания</span>
        <v-menu
          ref="menuEndDate"
          :close-on-content-click="false"
          min-width="auto"
          v-model="menuEndDate"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-row align="center" no-gutters>
              <v-text-field
                hide-details
                outlined
                readonly
                v-bind="attrs"
                :disabled="loading || fields.repeatType === 'NO_REPEAT' || isOnlyEdit"
                :loading="loading"
                :error-messages="getFieldErrorMessage('endDate', 'Обязательное поле')"
                :value="preparedFormatTime(fields.endDate)"
                v-on="on"
                @change="fields.endDate = prepareDateFormatPayload($event)"
              />
              <v-icon class="ml-2">mdi-calendar</v-icon>
            </v-row>
          </template>
          <v-date-picker
            no-title
            scrollable
            first-day-of-week="1"
            :min="fields.startDate"
            :value="fields.endDate"
            :disabled="loading || fields.repeatType === 'NO_REPEAT' || isOnlyEdit"
            @change="fields.endDate = prepareDateFormatPayload($event)"
            @input="menuEndDate = false"
          >
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row
      v-for="(scheduleTime, scheduleTimeIndex) in fields.scheduleTimes"
      :key="scheduleTimeIndex"
    >
      <v-col cols="6">
        <span>Время с*</span>
        <TimePicker
        id="startTime"
          v-model="fields.scheduleTimes[scheduleTimeIndex].startTime"
          :loading="loading"
          :disabled="loading || isOnlyEdit"
          :error-messages="getFieldErrorMessage('scheduleTimes','Обязательное поле','startTime', scheduleTimeIndex)"
        />
      </v-col>
      <v-col cols="6">
        <span>Время по *</span>
        <TimePicker
        id="endTime"
          v-model="fields.scheduleTimes[scheduleTimeIndex].endTime"
          :loading="loading"
          :disabled="loading || isOnlyEdit"
          :error-messages="getFieldErrorMessage('scheduleTimes','Обязательное поле','endTime', scheduleTimeIndex)"
        />
      </v-col>
      <v-col cols="2">
        <v-btn
          v-if="scheduleTimeIndex > 0"
          icon
          @click="deleteScheduleTime(scheduleTime.id, scheduleTimeIndex)"
        >
          <v-icon color="red">mdi-trash-can-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="!isOnlyEdit">
      <v-col>
        <v-btn
          @click="createTimeSlot"
          :disabled="loading"
          :loading="loading"
          >Добавить</v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <span>Название *</span>
        <v-text-field
          outlined
          id="name"
          :disabled="loading || isOnlyEdit"
          :loading="loading"
          :error-messages="getFieldErrorMessage('name', 'Обязательное поле')"
          v-model="fields.name"
        />
      </v-col>
    </v-row>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        text
        color="grey darken-2"
        :disabled="loading"
        :loading="loading"
        @click="$emit('close')"
        >{{ isOnlyEdit ? 'Закрыть' : 'Отменить' }}</v-btn
      >
      <v-btn
        v-if="!isOnlyEdit"
        text
        color="primary darken-2"
        :disabled="loading"
        :loading="loading"
        @click="submitEventScheduleForm"
        >{{ data ? 'Сохранить' : 'Создать' }}</v-btn
      >
    </v-card-actions>
  </v-container>
</template>

<script>
import moment from 'moment'
import { repeatTypes, weekDays, defaultDateFormat, apiFormat } from '@/configs/date'
import validationRules from './validation-rules'
import { getUtcOffsetTimeZone } from '@/utils'

import FormAbstract from '@/components/abstract/form'

import deleteEventScheduleMutation from '@/services/gql/types/EventSchedules/mutations/deleteEventSchedule.gql'
import deleteScheduleTimeMutation from '@/services/gql/types/ScheduleTimes/mutations/deleteScheduleTime.gql'
import dayjs from 'dayjs'
import TimePicker from '@/components/inputs/TimePicker'

class ScheduleTime {
  id = null
  startTime = null
  endTime = null
}

export default {
  components: { TimePicker },
  extends: FormAbstract,
  name: 'FormEventSchedules',
  repeatTypes,
  weekDays,
  defaultDateFormat,
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    idx: {
      type: Number,
      default: null
    },
    timezone: {
      type: String,
      default: 'Europe/Moscow'
    },
    isOnlyEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fields: {
        name: null,
        startDate: null,
        endDate: null,
        scheduleTimes: [],
        repeatType: repeatTypes[1].id,
        repeatWeekdays: []
      },
      menuStartDate: false,
      menuEndDate: false
    }
  },
  computed: {
    isValidEventSchedules () {
      if (this.fields.scheduleTimes?.length < 1) return false
      return this.fields.scheduleTimes.reduce((acc, scheduleTime) => {
        if (!scheduleTime.startTime || !scheduleTime.endTime) acc = false
        return acc
      }, true)
    },
    isEndDateRequiredFields () {
      return this.fields.repeatType !== 'NO_REPEAT'
    },
    validationRules () {
      return validationRules({
        endDateRequired: this.isEndDateRequiredFields
      })
    }
  },
  watch: {
    data (newVal) {
      if (newVal) {
        this.populate(newVal)
        this.populateEventSchedules(newVal?.scheduleTimes || newVal?.scheduleTimes)
      }
      this.$v.$reset()
    },
    fields: {
      deep: true,
      handler (newVal) {
        if (newVal?.repeatType === 'NO_REPEAT') {
          if (!this.fields.startDate) {
            this.fields.startDate = this.prepareDateFormatPayload(
              dayjs().tz('Europe/Moscow').startOf('day').format()
            )
          }
        }
      }
    }
  },
  methods: {
    resetWeekDays () {
      this.fields.repeatWeekdays = []
    },
    repeatTypeHandler (value) {
      this.resetWeekDays()
      this.fields.repeatType = value
    },
    preparedFormatTime (value) {
      if (value !== null) {
        return dayjs(value || new Date())
          // .tz('Europe/Moscow') need to check it in future
          .format(defaultDateFormat)
      }
      return value
    },
    prepareDateFormatPayload (value) {
      return moment(value).format(apiFormat)
    },
    populateEventSchedules (list) {
      this.fields.scheduleTimes = list
      if (!list?.length) {
        this.createTimeSlot()
      } else {
        this.fields.scheduleTimes = list.map(scheduleTime => {
          return {
            id: scheduleTime.id,
            startTime: scheduleTime?.startTime.slice(0, 5) || null,
            endTime: scheduleTime?.endTime.slice(0, 5) || null
          }
        })
      }
    },
    preparedEventSchedules () {
      this.fields.scheduleTimes = this.fields.scheduleTimes.map(scheduleTime => {
        return {
          id: scheduleTime?.id || null,
          startTime: scheduleTime.startTime
            ? scheduleTime.startTime?.length > 5
              ? scheduleTime.startTime
              : `${scheduleTime.startTime}:00`
            : '',
          endTime: scheduleTime.endTime
            ? scheduleTime.endTime?.length > 5
              ? scheduleTime.endTime
              : `${scheduleTime.endTime}:00`
            : ''
        }
      })
    },
    createTimeSlot () {
      if (this.fields?.scheduleTimes) {
        this.fields.scheduleTimes.push(new ScheduleTime())
      }
    },
    updateTimeSlot (index, field, value) {
      this.fields.scheduleTimes[index][field] = value
    },
    async deleteScheduleTime (id = null, index) {
      if (id) {
        this.fields.scheduleTimes.splice(index, 1)
        await this.$async.deleteScheduleTime.$perform({ id })
      } else {
        this.fields.scheduleTimes.splice(index, 1)
      }
    },
    async submitEventScheduleForm () {
      const isValid = await this.validate()
      if (!isValid || !this.isValidEventSchedules) {
        this.mixScrollToError(this.$v)
        return
      }
      this.preparedEventSchedules()
      const id = this.data?.id || null
      const payload = id
        ? {
          ...this.preparedFormatDate(this.composeFormData(this.fields)),
          idx: this.idx,
          id
        }
        : {
          ...this.preparedFormatDate(this.composeFormData(this.fields)),
          idx: this.idx
        }
      this.$emit('change-event-schedules', payload)
    },
    preparedFormatDate (data) {
      if (!data) return
      return {
        ...data,
        startDate: dayjs(data?.startDate)
          .utc(true)
          .add(getUtcOffsetTimeZone(this.timezone), 'hour')
          .startOf('day')
          .format(),
        endDate: dayjs(
          this.fields?.repeatType === 'NO_REPEAT' ? data?.startDate : data?.endDate
        )
          .utc(true)
          .startOf('day')
          .add(getUtcOffsetTimeZone(this.timezone), 'hour')
          .endOf(this.fields?.repeatType === 'NO_REPEAT' ? 'day' : '')
          .format()
      }
    },
    openDialog () {
      if (this.data) {
        this.populate(this.data)
        this.populateEventSchedules(this.data.scheduleTimes)
      }
    },
    closeDialog () {
      this.clearFields()
      this.createTimeSlot()
      this.$v.$reset()
    },
    clearFields () {
      this.fields = {
        name: null,
        startDate: null,
        endDate: null,
        scheduleTimes: [],
        repeatType: repeatTypes[1].id,
        repeatWeekdays: []
      }
    },
    getFieldErrorMessage (...args) {
      const [fieldName, msg, each, idx] = args
      if (!each) {
        if (this.$v.fields[fieldName] === undefined) return ''
        const v = this.$v.fields[fieldName]
        return v.$invalid && v.$dirty ? [msg] : []
      } else {
        const v = this.$v.fields[fieldName].$each.$iter[idx][each]
        return v.$invalid && v.$dirty ? [msg] : []
      }
    }
  },
  async: {
    deleteEventSchedule (variables) {
      return this.$apollo.mutate({
        mutation: deleteEventScheduleMutation,
        variables
      })
    },
    deleteScheduleTime (variables) {
      return this.$apollo.mutate({
        mutation: deleteScheduleTimeMutation,
        variables
      })
    }
  },
  mounted () {
    if (this.data !== null) {
      this.populate(this.data)
      this.populateEventSchedules(this.data.scheduleTimes)
    } else {
      this.createTimeSlot()
    }
    this.$v.$reset()
  }
}
</script>
